import * as types from '../types';
import { common } from '~api';

const {
  apiGetCustomType,
  apiGetContactsType,
  apiGetVisitType,
  apiGetCrmAuth,
  apiGetClerkList,
  apiGetSigninTeams,
  apiGetCategory,
  apiUploadBusinessCard,
} = common;

export default {
  // 获取客户类型
  getCustomType({ commit }, payload) {
    return apiGetCustomType({ code: 'category_customer', ...payload })
      .then((res) => {
        console.log(res, 'res-getCustomType');
        commit(types.GET_CUSTOM_TYPE, res.data.results);
      })
      .catch(() => {});
  },
  //  获取客户等级
  getCustomerLevel({ commit }, payload) {
    return apiGetCustomType({ code: 'category_customer_level', ...payload })
      .then((res) => {
        commit(types.GET_CUSTOM_LEVEL, res.data.results);
      })
      .catch(() => {});
  },
  // 获取联系人类型
  getContactsType({ commit }, payload) {
    return apiGetContactsType(payload)
      .then((res) => {
        commit(types.GET_CONTACTS_TYPE, res.data);
      })
      .catch(() => {});
  },
  // 获取拜访方式
  getVisitType({ commit }, payload) {
    return apiGetVisitType(payload)
      .then((res) => {
        commit(types.GET_VISIT_TYPE, res.data);
      })
      .catch(() => {});
  },
  // 新的获取用户权限
  getCrmAuth({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiGetCrmAuth(payload)
        .then((res) => {
          if (res && res.data) {
            commit(types.GET_CRM_AUTH, res.data);
          }
          resolve();
        })
        .catch(err => reject(err));
    });
  },
  // 获取业务员列表
  getClerkList({ commit }, payload) {
    return apiGetClerkList(payload)
      .then((res) => {
        const data = res.data.data;
        commit(types.GET_CLERK_LIST, data);
      })
      .catch(() => {});
  },
  // 获取签到团队
  getSigninTeams({ commit }, payload) {
    return apiGetSigninTeams(payload)
      .then((res) => {
        const data = res.data;
        commit(types.GET_SIGNIN_TEAMS, data);
      })
      .catch(() => {});
  },

  // 获取服务类型
  getServiceType({ commit }, payload) {
    return apiGetCategory(payload)
      .then((res) => {
        const data = res.data;
        commit(types.GET_SERVICE_TYPE, data);
      })
      .catch(() => {});
  },
  // 获取合作模式
  getModeType({ commit }, payload) {
    return apiGetCategory(payload)
      .then((res) => {
        const data = res.data;
        commit(types.GET_MODE_TYPE, data);
      })
      .catch(() => {});
  },
  // 获取结算方式
  getSettlementSource({ commit }, payload) {
    return apiGetCategory({ code: 'category_settlement_type' })
      .then((res) => {
        const data = res.data;
        commit(types.GET_SETTLEMENT_SOURCE, data);
      })
      .catch(() => {});
  },
  // 获取线索来源
  getClueSource({ commit }, payload) {
    return apiGetCategory(payload)
      .then((res) => {
        const data = res.data;
        commit(types.GET_CLUE_SOURCE, data);
      })
      .catch(() => {});
  },
  // 获取线索来源
  getInvalidReason({ commit }, payload) {
    return apiGetCategory(payload)
      .then((res) => {
        const data = res.data;
        commit(types.GET_INVALID_REASON, data);
      })
      .catch(() => {});
  },
  // 获取考察性质
  getInvestigationNature({ commit }, payload) {
    return apiGetCategory(payload)
      .then((res) => {
        const data = res.data;
        commit(types.GET_INVESTIGATION_NATURE, data);
      })
      .catch(() => {});
  },
  // 获取考察类别
  getInvestigationCategory({ commit }, payload) {
    return apiGetCategory(payload)
      .then((res) => {
        const data = res.data;
        commit(types.GET_INVESTIGATION_CATEGORY, data);
      })
      .catch(() => {});
  },
  // 接待等级
  getReceptionLevel({ commit }, payload) {
    return apiGetCategory(payload)
      .then((res) => {
        const data = res.data;
        commit(types.GET_RECEPTION_LEVEL, data);
      })
      .catch(() => {});
  },
  // 项目阶段
  getProjectStage({ commit }, payload) {
    return apiGetCategory(payload)
      .then((res) => {
        const data = res.data;
        commit(types.GET_PROJECT_STAGE, data);
      })
      .catch(() => {});
  },
  // 上传名片
  uploadBusinessCard({ commit }, payload) {
    return apiUploadBusinessCard(payload.params, payload.config);
  },
};
